export const ds_ImageAndLinksColumnsBlock_Entry = `
    fragment ds_ImageAndLinksColumnsBlock_Entry on ds_ImageAndLinksColumnsBlock_Entry {
        id
        canonicalUid

        imageAndLinksColumns_ColorTheme
        imageAndLinksColumns_ColorPalette
        imageAndLinksColumns_TopSpacing
        imageAndLinksColumns_ContainerWidth
        imageAndLinksColumns_FullWidthBackground

        imageAndLinksColumns_Heading
        imageAndLinksColumns_Subheading
        imageAndLinksColumns_ImagePlacement
        imageAndLinksColumns_ColumnsDesktop
        imageAndLinksColumns_BodyText

        # imageAndLinksColumns_LinksHeading
        imageAndLinksColumns_Image {
            url @transform (width: 550, height: 550)
            alt
            focalPoint
        }

        imageAndLinksColumns_Links {
            text
            target
            url
            ... on imageAndLinksColumns_Links_Custom_LinkType {
              description
              icon {
                    name
                    set
                    type
                }
            }
            ... on imageAndLinksColumns_Links_Entry_LinkType {
              description
              icon {
                    name
                    set
                    type
                }
            }
            ... on imageAndLinksColumns_Links_Url_LinkType {
              description
              icon {
                    name
                    set
                    type
                }
            }
            ... on imageAndLinksColumns_Links_Phone_LinkType {
              description
              icon {
                    name
                    set
                    type
                }
            }
            ... on imageAndLinksColumns_Links_Email_LinkType {
              description
              icon {
                    name
                    set
                    type
                }
            }
        }
    }
`
